import { COMMA, ENTER } from "@angular/cdk/keycodes";
import { Component, OnInit } from "@angular/core";
import { MatChipInputEvent } from "@angular/material/chips";
import { Router } from "@angular/router";
import {
  AlertController,
  LoadingController,
  ToastController,
} from "@ionic/angular";
import { STORAGE } from "src/app/constant/storages";
import { ApiserviceService } from "src/app/httpservice/apiservice.service";
import { AppService } from "src/app/services/app.service";
import { _getStorage, _setStorage } from "src/app/utils/local-storage";
import { errMsg } from "../../../text_control/error-msg";
import { ADDRESS } from "../../../text_control/text_address";
import { BTN } from "../../../text_control/text_button";

export interface Phones {
  numbers: string;
}

export interface TelEN {
  telENName: string;
}
@Component({
  selector: "app-add-no-taxinvoice",
  templateUrl: "./add-no-taxinvoice.component.html",
  styleUrls: ["./add-no-taxinvoice.component.scss"],
})
export class AddNoTaxinvoiceComponent implements OnInit {
  public text_addr: any = {};
  public text_btn: any = {};
  public data = {
    buyer_name: "",
    seller_id: null,
    building_no: "",
    room_no: "",
    floor: "",
    building_name: "",
    house_no: "",
    village_no: "",
    lane: "",
    road: "",
    postcode: "",
    phone: "",
    email: "",
  };

  phone: any = "";
  buyer_agree_tmp: any = "Y";
  dataAbb: any = [];
  sub_district = "";
  district = "";
  province = "";
  redioaddress = "1";
  showaddrTH = false;
  showaddrEN = false;
  showTH = false;
  showEN = false;
  showaddr = false;

  emailEN = "";
  telEN = "";
  addrENCountry = "";
  addrENPostCode = "";
  addrENProvince = "";
  addrEN: String = "";
  addrENOther = "";
  dataCountry: any = [];
  country: any = "";
  dataCountrysearch: any = [];
  dataphone: any;

  showback = false;
  showrefresh = false;
  showsave = false;
  shownext = false;

  dataProvince: any;
  groupAddress: any;
  groupProvince: any;
  isFindAddress = false;
  searchAddress = "";
  searchProvince = "";
  addressManual = false;

  userID = "";
  userBu = "";
  userLoc = "";
  userRole = "";
  userSource = "";

  isAddress = false;
  addressline1 = "";

  constructor(
    public apiservice: ApiserviceService,
    public toastController: ToastController,
    public alertController: AlertController,
    public appService: AppService,
    public router: Router,
    public loadingController: LoadingController
  ) {
    this.userID = _getStorage(STORAGE.userID);
    this.userRole = _getStorage(STORAGE.userRole);
    this.userBu = _getStorage(STORAGE.userBu);
    this.userLoc = _getStorage(STORAGE.userLoc);

    this.text_addr = ADDRESS;
    this.text_btn = BTN;
  }

  ngOnInit() {
    this.addressManual = false;
    this.groupAddress = this.appService.address_thai;
    window.onclick = function (event) {
      var x = document.getElementById("showselect");
      var y = document.getElementById("notshowselect");
      var showprovince = document.getElementById("showSelectProvince");
      var notshowprovince = document.getElementById("notshowselectProvince");
      if (x !== null) {
        x.style.display = "none";
        y.style.display = "none";
      }
      if (showprovince !== null) {
        showprovince.style.display = "none";
        notshowprovince.style.display = "none";
      }
    };
    let groupData = [];
    this.groupAddress.forEach((v, i) => {
      const index = groupData.findIndex((f) => f.province === v.province);
      if (index === -1) {
        groupData = [...groupData, v];

        this.dataProvince = groupData;
      } else {
        return;
      }
    });
  }

  checkAddress(e) {
    console.log("checkAddress event =======:: ", e);
    this.isAddress = e.detail.checked;
  }

  filterAddress(e) {
    let val = e.target.value;
    if (val.trim() !== "") {
      this.groupAddress = this.appService.address_thai.filter((item) => {
        return (
          String(item.zipcode).indexOf(val) > -1 ||
          item.province.indexOf(val) > -1 ||
          item.amphoe.indexOf(val) > -1 ||
          item.district.indexOf(val) > -1
        );
      });
      var x = document.getElementById("showselect");
      var y = document.getElementById("notshowselect");
      if (this.groupAddress.length > 0) {
        y.style.display = "none";
        if (x.style.display === "none") {
          x.style.display = "block";
        }
      } else {
        x.style.display = "none";
        if (y.style.display === "none") {
          y.style.display = "block";
        }
      }
    }
  }

  selectAddress(item) {
    this.sub_district = item.district;
    this.district = item.amphoe;
    this.province = item.province;
    this.data.postcode = item.zipcode;
    this.isFindAddress = false;
    this.searchAddress = "";
  }
  filterProvince(e) {
    let val = e.target.value;
    if (val.trim() !== "") {
      this.groupProvince = this.dataProvince.filter((item) => {
        return item.province.indexOf(val) > -1;
      });
      var x = document.getElementById("showSelectProvince");
      var y = document.getElementById("notshowselectProvince");
      if (this.groupAddress.length > 0) {
        y.style.display = "none";
        if (x.style.display === "none") {
          x.style.display = "block";
        }
      } else {
        x.style.display = "none";
        if (y.style.display === "none") {
          y.style.display = "block";
        }
      }
    }
  }
  selectProvince(item) {
    this.province = item.province;
    this.searchProvince = "";
  }
  clearAddress(name) {
    if (name === "Postcode") {
      this.data.postcode = "";
    }
    if (name === "Province") {
      this.province = "";
    }
    if (name === "District") {
      this.district = "";
    }
    if (name === "SubDistrict") {
      this.sub_district = "";
    }
  }
  ionViewDidEnter() {
    var showprovince = document.getElementById("showSelectProvince");
    var notshowprovince = document.getElementById("notshowselectProvince");

    if (showprovince !== null) {
      showprovince.style.display = "none";
      notshowprovince.style.display = "none";
    }

    let listdata = _getStorage(STORAGE.DATA_SEARCH_NO__TAXINVOICE);
    let buyer_name = listdata.searchCustomerData.company_name;
    this.dataphone = listdata.searchCustomerData.phone;
    for (let i of this.dataphone) {
      this.phones.push({
        numbers: i,
      });
    }
    this.reloadcountry();
    this.showback = true;
    this.showsave = true;
    this.showrefresh = true;
    this.shownext = false;
    this.checkredioaddr();

    this.data = {
      buyer_name: buyer_name,
      seller_id: null,
      building_no: "",
      building_name: "",
      house_no: "",
      room_no: "",
      floor: "",
      village_no: "",
      lane: "",
      road: "",
      postcode: "",
      phone: "",
      email: "",
    };

    this.phone = "";
    this.buyer_agree_tmp = "Y";
    this.dataAbb = [];
    this.sub_district = "";
    this.district = "";
    this.province = "";

    this.redioaddress = "1";
    this.showaddrTH = false;
    this.showaddrEN = false;
    this.showTH = false;
    this.showEN = true;
    this.showaddr = false;

    this.emailEN = "";
    this.telEN = "";
    this.addrENCountry = "";
    this.addrENPostCode = "";
    this.addrENProvince = "";
    this.addrEN = "";
    this.addrENOther = "";
    this.dataCountry = [];
    this.country = "";
    this.dataCountrysearch = [];
    this.reloadcountry();
  }

  checkredioaddr() {
    if (this.redioaddress === "1") {
      this.showTH = false;
      this.showEN = true;
    }
    if (this.redioaddress === "2") {
      this.showTH = true;
      this.showEN = false;
    }
  }

  checkaddressTH() {
    this.showTH = false;
    this.showEN = true;
  }
  checkaddressEN() {
    this.showTH = true;
    this.showEN = false;
  }
  reloadcountry() {
    // this.addrENCountry = this.appService.Country[0]
    this.dataCountry = this.appService.Country;
    this.dataCountrysearch = this.appService.Country;
  }

  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];
  phones: Phones[] = [];

  add(e: MatChipInputEvent, n): void {
    const input = e.input;
    const value = e.value;

    // Add our fruit
    if ((value || "").trim()) {
      this.phones.push({ numbers: value.trim() });
    }

    // Reset the input value
    if (input) {
      input.value = "";
    }
  }

  remove(phone: Phones): void {
    const index = this.phones.indexOf(phone);

    if (index >= 0) {
      this.phones.splice(index, 1);
    }
  }

  searchaddrEN(search) {
    let val: string = search;
    if (val.trim() !== "") {
      this.dataCountry = this.dataCountrysearch.filter((item) => {
        return item.name.toLowerCase().indexOf(val.toLowerCase()) > -1;
      });
    }

    if (val === "") {
      this.reloadcountry();
    }
  }
  checkpostcode(e) {
    this.data.postcode = e.target.value.match(/[0-9]*/)[0];
  }
  checkPostcodeEN(e) {
    this.addrENPostCode = e.target.value.match(/[0-9]*/)[0];
  }
  checkphone(e) {
    this.phone = e.target.value.match(/[0-9]*/)[0];
  }
  checkphoneEN(e) {
    this.telEN = e.target.value.match(/[0-9]*/)[0];
  }
  checkemail(e) {
    this.data.email = e.target.value.match(/[0-9a-z._@A-Z- ]*/)[0];
  }
  checkemailEN(e) {
    this.emailEN = e.target.value.match(/[0-9a-z._@A-Z- ]*/)[0];
  }
  async ErrorMsg(message: string) {
    let alert = await this.alertController.create({
      cssClass: "my-custom-class",
      message: message,
      buttons: [
        {
          text: "OK",
          cssClass: "alertButton",
          handler: (blah) => {
            //
          },
        },
      ],
    });
    await alert.present();
  }

  dataTH: any;
  dataEN: any;

  async save() {
    let isConfirm = false;
    let province = this.province;
    let district = this.district;
    let sub_district = this.sub_district;
    let phones = [];

    for (let i of this.phones) {
      phones.push(i.numbers);
    }

    if (this.isAddress === true && this.addressline1 === "")
      return this.ErrorMsg(errMsg.errorAddressline1);

    if (this.isAddress === true && this.data.postcode === "") {
      return this.ErrorMsg(errMsg.postcode);
    }
    if (this.isAddress === true && this.data.buyer_name === "") {
      return this.ErrorMsg(errMsg.buyer_company_name);
    }

    if(this.isAddress === false){

    if (this.redioaddress === "1") {
      if (!isConfirm) {
        let filterPostcode = this.groupAddress.filter(
          (f) => f.zipcode === Number(this.data.postcode)
        );
        let filterProvince = this.groupAddress.filter(
          (f) => f.province === this.province
        );

        if (this.data.buyer_name === "") {
          this.ErrorMsg(errMsg.buyer_company_name);
        } else if (this.data.house_no === "") {
          this.ErrorMsg(errMsg.house_no);
        } else if (this.data.postcode === "") {
          this.ErrorMsg(errMsg.postcode);
        } else if (this.data.postcode !== "" && filterPostcode.length === 0) {
          this.ErrorMsg(errMsg.notpostcode);
        } else if (sub_district === "") {
          this.ErrorMsg(errMsg.sub_district);
        } else if (district === "") {
          this.ErrorMsg(errMsg.district);
        } else if (province === "") {
          this.ErrorMsg(errMsg.province);
        } else if (province !== "" && filterProvince.length === 0) {
          this.ErrorMsg(errMsg.notprovince);
        } else if (this.data.email !== "") {
          const re =
            /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          if (!re.test(this.data.email)) {
            this.ErrorMsg(errMsg.errorEmail);
          } else {
            isConfirm = true;
          }
        } else {
          isConfirm = true;
        }
      }
    } else {
      if (!isConfirm) {
        if (this.data.buyer_name === "") {
          this.ErrorMsg(errMsg.buyer_company_name);
        } else if (
          this.addrENProvince === "" ||
          this.addrENProvince === undefined
        ) {
          this.ErrorMsg(errMsg.addrENProvince);
        } else if (
          this.addrENPostCode === "" ||
          this.addrENPostCode === undefined
        ) {
          this.ErrorMsg(errMsg.addrENPostCode);
        } else if (
          this.addrENCountry === "" ||
          this.addrENCountry === undefined
        ) {
          this.ErrorMsg(errMsg.addrENCountry);
        } else if (this.emailEN !== "") {
          const re =
            /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          if (!re.test(this.emailEN)) {
            this.ErrorMsg(errMsg.errorEmail);
          } else {
            isConfirm = true;
          }
        } else {
          isConfirm = true;
        }
      }
    }
  }else{
    isConfirm = true
  }

    if (isConfirm) {
      const req_no_texid = {
        newCustomerData: {
          buyer_company_name: this.data.buyer_name,
          buyer_people_id: "",
          buyer_main_branch_no: "",
          buyer_branch_no: "",
          buyer_citizen_id: "",
          buyer_tax_id: "",
          buyer_passpost_id: "",
          buyer_type: "3",
          buyer_agree_tmp: this.buyer_agree_tmp,
          user_id: this.userID,
          template_lang: this.redioaddress === "1" ? "TH" : "EN",
          buyer_status: "active",
          address_detail: {
            type_addr: this.redioaddress,
            building_no: this.data.building_no,
            building_name: this.data.building_name,
            house_no: this.data.house_no,
            village_no: this.data.village_no,
            room_no: this.data.room_no,
            floor: this.data.floor,
            lane: this.data.lane,
            road: this.data.road,
            sub_district: sub_district,
            district: district,
            province: province,
            postcode: String(this.data.postcode),
            phone: phones.join(","),
            email: this.redioaddress === "1" ? this.data.email : this.emailEN,
            address_status: "active",
            addr_agree_tmp: this.buyer_agree_tmp,
            seller_id: "",
            buyer_id: "",
            user_id: this.userID,
            inter_country: !this.addrENCountry ? "" : this.addrENCountry,
            inter_tel: !this.telEN ? "" : this.telEN,
            inter_province: !this.addrENProvince ? "" : this.addrENProvince,
            inter_postcode: !this.addrENPostCode ? "" : this.addrENPostCode,
            inter_address_line1: !this.addrEN ? "" : this.addrEN,
            inter_fax: "",
            is_addresstxt: this.isAddress,
            addressline1: this.addressline1 || "",
          },
        },
      };

      console.log("REQ DATA SAVE NO TAXID ==============: ", req_no_texid);

      try {
        this.apiservice
          ._post(
            this.apiservice.apiUrl + this.apiservice.updateCustomer,
            req_no_texid
          )
          .then(async (res: any) => {
            console.log(" REQ DATA SAVE NO TAXID==============: ", res);
            if (res.statusCode === 200) {
              this.dataAbb = res.data[0];
              const alert = await this.alertController.create({
                cssClass: "my-custom-class",
                message: "บันทึกข้อมูลเรียบร้อย",
                buttons: [
                  {
                    text: "OK",
                    cssClass: "alertButton",
                    handler: (blah) => {
                      this.showTH = true;
                      this.showEN = true;
                      this.showaddr = true;
                      this.showrefresh = false;
                      this.showsave = false;
                      this.shownext = true;
                      this.showback = false;
                    },
                  },
                ],
              });
              await alert.present();
            } else {
              this.ErrorMsg(res.statusMessage);
            }
          });
      } catch (error) {
        // this.ErrorMsg(errMsg.error);
      }
    }
  }
  backNotaxinvoice() {
    this.router.navigate(["/select-no-taxinvoice"]);
  }
  setnextstorage() {
    _setStorage(STORAGE.DATA_ADD_NO__TAXINVOICE,this.dataAbb)
    this.router.navigate(["/check-no-taxinvoice"], {
      queryParams: { noName: "no_tax", selectedIndex: "4" },
    });
  }
}
